import { render, staticRenderFns } from "./NotExported.vue?vue&type=template&id=1f3be4b0&"
import script from "./NotExported.vue?vue&type=script&lang=js&"
export * from "./NotExported.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports